(function () {
/**
 * Main JS file for Paragon Underscores theme
 *
 * Will be compiled into js/main.js
 */ /**
 * Set a cookie to remember the user's choice.
 *
 * @param {HTMLElement} alertBanner - The alert banner element.
 */ function $810e55176b9a1362$var$setCookie(alertBanner) {
    // Set a one-week cookie to remember the user's choice.
    const effectiveDate = alertBanner.getAttribute('data-effective-date');
    const date = new Date();
    date.setTime(date.getTime() + 604800000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `PDM_ALERT_BANNER=${effectiveDate}; ${expires}; path=/; Secure; SameSite=Strict`;
}
/**
 * Animate the closing of the banner.
 *
 * @param {HTMLElement} alertBanner
 *
 * @return {void}
 */ function $810e55176b9a1362$var$animateToClose(alertBanner) {
    const alertBannerClose = alertBanner.querySelector('[data-action="alert-banner-close"]');
    alertBanner.classList.add('shrink-height');
    alertBannerClose.style.display = 'none';
    alertBanner.addEventListener('animationend', function handleShrinkHeight() {
        alertBanner.classList.remove('shrink-height');
        alertBanner.style.display = 'none';
    }, {
        once: true
    });
}
/**
 * Handle closing the alert banner.
 */ function $810e55176b9a1362$export$2c14ca4feaecad60() {
    const alertBanner = document.querySelector('[data-element="alert-banner"]');
    if (!alertBanner) return;
    // Check if the user has already closed the alert banner.
    const cookies = document.cookie.split(';');
    const cookie = cookies.find((cookieContent)=>cookieContent.includes('PDM_ALERT_BANNER'));
    const effectiveDate = alertBanner.getAttribute('data-effective-date');
    // If there's no cookie set or if the cookie effective date is different, show the banner.
    if (!cookie || !cookie.includes(effectiveDate)) alertBanner.style.display = 'block';
    const alertBannerClose = alertBanner.querySelector('[data-action="alert-banner-close"]');
    if (!alertBannerClose) return;
    alertBannerClose.addEventListener('click', ()=>{
        $810e55176b9a1362$var$setCookie(alertBanner);
        $810e55176b9a1362$var$animateToClose(alertBanner);
    });
}


/**
 * Desktop navigation
 *
 * This script adds accessibility features to the desktop navigation menu.
 *
 * The mobileBreakpoint variable must be set to the same value as the
 * CSS media query breakpoint in _main-navigation.scss and _mobile-navigation.scss,
 * as well as the mobileNavigation.js file.
 *
 * @package
 */ /**
 * Adds accessibility features to the desktop navigation menu.
 *
 * @return {void}
 */ function $bea2d471bd0cd2e0$export$20a6ab5ff56edf57() {
    const siteNavigation = document.getElementById('site-navigation');
    // Return early if the navigation doesn't exist.
    if (!siteNavigation) return;
    // Get the mobile breakpoint variable from CSS to use with the resize observer.
    const mobileBreakpoint = getComputedStyle(siteNavigation).getPropertyValue('--pdm-menu-breakpoint');
    const menu = siteNavigation.getElementsByTagName('ul')[0];
    // Get all the link elements within the menu.
    const links = menu.getElementsByTagName('a');
    // Get all the link elements with children within the menu.
    const linksWithChildren = menu.querySelectorAll('.menu-item-has-children > a, .page_item_has_children > a');
    // Toggle focus each time a menu link is focused or blurred.
    for (const link of links){
        link.addEventListener('focus', toggleFocus, true);
        link.addEventListener('blur', toggleFocus, true);
    }
    // Toggle focus each time a menu link with children receive a touch event.
    for (const link of linksWithChildren)link.addEventListener('touchstart', toggleFocus, false);
    /**
	 * Sets or removes .focus class on an element.
	 */ function toggleFocus() {
        // if the viewport is under 800px, don't toggle focus
        if (window.innerWidth < mobileBreakpoint) return;
        if (event.type === 'focus' || event.type === 'blur') {
            let self = this;
            // Move up through the ancestors of the current link until we hit .nav-menu.
            while(!self.classList.contains('nav-menu')){
                // On li elements toggle the class .focus.
                if ('li' === self.tagName.toLowerCase()) self.classList.toggle('focus');
                self = self.parentNode;
            }
        }
        if (event.type === 'touchstart') {
            const menuItem = this.parentNode;
            event.preventDefault();
            for (const link of menuItem.parentNode.children)if (menuItem !== link) link.classList.remove('focus');
            menuItem.classList.toggle('focus');
        }
    }
}


/**
 * Mobile navigation
 *
 * This script adds features to show and hide the mobile navigation menu.
 *
 * The mobileBreakpoint variable must be set to the same value as the
 * CSS media query breakpoint in _main-navigation.scss and _mobile-navigation.scss,
 * as well as the desktopNavigation.js file.
 *
 * @package
 */ /**
 * Closes the mobile navigation menu and restores its aria and body-scroll state.
 *
 * @return {void}
 */ function $01defc33d8586d8c$var$closeMobileMenu() {
    const openButton = document.querySelector('.main-navigation-open');
    const closeButton = document.querySelector('.main-navigation-close');
    openButton.setAttribute('aria-expanded', 'false');
    closeButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('main-navigation-menu-open');
    document.body.style.overflow = 'auto';
    $01defc33d8586d8c$var$removeMobileStyles();
}
/**
 * Opens the mobile navigation menu, focuses its first link, and closes it on outside focus.
 *
 * @return {void}
 */ function $01defc33d8586d8c$var$openMobileMenu() {
    const openButton = document.querySelector('.main-navigation-open');
    const closeButton = document.querySelector('.main-navigation-close');
    openButton.setAttribute('aria-expanded', 'true');
    closeButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('main-navigation-menu-open');
    document.body.style.overflow = 'hidden';
    // Set focus to the first link in the open menu
    const menu = document.getElementById('site-navigation');
    const focusableElements = menu.querySelectorAll('a');
    const firstFocusableElement = focusableElements[0];
    firstFocusableElement.focus();
    // close the menu if anything outside the menu gains focus
    document.addEventListener('focusin', function(event) {
        if (!menu.contains(event.target)) $01defc33d8586d8c$var$closeMobileMenu();
    }, true);
}
/**
 * Animates an element's height from 0 to its natural height to reveal a submenu.
 *
 * @param {HTMLElement} element - The submenu element to reveal.
 *
 * @return {void}
 */ function $01defc33d8586d8c$var$animateOpen(element) {
    element.style.height = 'auto'; // Set height to auto
    const height = element.offsetHeight; // Get actual height
    element.style.height = '0px'; // Reset to 0
    // Animate using requestAnimationFrame for smooth performance
    requestAnimationFrame(()=>{
        let currentHeight = 0;
        const step = 10; // Adjust for animation speed
        element.style.visibility = 'visible';
        const interval = setInterval(()=>{
            currentHeight += step;
            element.style.height = `${currentHeight}px`;
            if (currentHeight >= height) clearInterval(interval);
        }, 10); // Adjust for animation speed
    });
}
/**
 * Animates an element's height down to 0 and hides it once collapsed.
 *
 * @param {HTMLElement} element - The submenu element to collapse.
 *
 * @return {void}
 */ function $01defc33d8586d8c$var$animateClose(element) {
    const height = element.offsetHeight; // Get actual height
    // Animate using requestAnimationFrame for smooth performance
    requestAnimationFrame(()=>{
        let currentHeight = height;
        const step = 10; // Adjust for animation speed
        const interval = setInterval(()=>{
            currentHeight -= step;
            element.style.height = `${currentHeight}px`;
            if (currentHeight <= 0) {
                clearInterval(interval);
                element.style.height = '0px'; // Reset to 0
            }
        }, 10); // Adjust for animation speed
    });
    setTimeout(()=>{
        element.style.visibility = 'hidden';
    }, 300); // Adjust for animation speed
}
/**
 * Clears the inline styles and aria/toggled state left behind by the submenu animations.
 *
 * @return {void}
 */ function $01defc33d8586d8c$var$removeMobileStyles() {
    // remove the inline styles added by the animateOpen and animateClose functions
    const subMenus = document.querySelectorAll('.sub-menu');
    for (const subMenu of subMenus){
        subMenu.style.height = '';
        subMenu.style.visibility = '';
    }
    // set all the sub-menu-toggle buttons to aria-expanded false
    const subMenuToggles = document.querySelectorAll('.sub-menu-toggle');
    for (const subMenuToggle of subMenuToggles)subMenuToggle.setAttribute('aria-expanded', 'false');
    // remove the .toggled class from all the menu items with submenus
    const menuItemsWithChildren = document.querySelectorAll('.menu-item-has-children');
    for (const menuItem of menuItemsWithChildren)menuItem.classList.remove('toggled');
}
function $01defc33d8586d8c$export$c8c5a7f7fe721969() {
    const siteNavigation = document.getElementById('site-navigation');
    const menu = siteNavigation.getElementsByTagName('ul')[0];
    const openButton = document.querySelector('.main-navigation-open');
    // Hide the menu toggle button if the menu is empty and return early.
    if ('undefined' === typeof menu) {
        openButton.style.display = 'none';
        return;
    }
    // Get the mobile breakpoint variable from CSS to use with the resize observer.
    const mobileBreakpoint = getComputedStyle(siteNavigation).getPropertyValue('--pdm-menu-breakpoint');
    if (!menu.classList.contains('nav-menu')) menu.classList.add('nav-menu');
    // Toggle the .toggled class and the aria-expanded value each time the buttons are clicked.
    openButton.addEventListener('click', function() {
        $01defc33d8586d8c$var$openMobileMenu();
    });
    const closeButton = document.querySelector('.main-navigation-close');
    closeButton.addEventListener('click', $01defc33d8586d8c$var$closeMobileMenu);
    // Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
    document.addEventListener('click', function(event) {
        const isClickInside = siteNavigation.contains(event.target);
        const isClickOpenButton = openButton.contains(event.target);
        if (!isClickInside && !isClickOpenButton) $01defc33d8586d8c$var$closeMobileMenu();
    });
    // Get the menu items with submenus
    const menuItemsWithChildren = menu.querySelectorAll('.nav-menu > .menu-item-has-children');
    // add a button to show the submenu after the link in the menu item
    for (const menuItem of menuItemsWithChildren){
        const menuItemLink = menuItem.querySelector('a');
        const menuItemButton = document.createElement('button');
        menuItemButton.setAttribute('aria-expanded', 'false');
        menuItemButton.setAttribute('aria-label', 'Show submenu');
        menuItemButton.setAttribute('class', 'sub-menu-toggle');
        menuItemButton.innerHTML = '<span class="screen-reader-text">Show submenu</span>';
        menuItem.insertBefore(menuItemButton, menuItemLink.nextSibling);
        // reveal the submenu when the button is clicked
        menuItemButton.addEventListener('click', function() {
            const isExpanded = menuItemButton.getAttribute('aria-expanded') === 'true';
            menuItemButton.setAttribute('aria-expanded', !isExpanded);
            menuItem.classList.toggle('toggled');
            const subMenu = menuItem.querySelector('.sub-menu');
            if (isExpanded) $01defc33d8586d8c$var$animateClose(subMenu);
            else $01defc33d8586d8c$var$animateOpen(subMenu);
        });
        // if the menu item is an empty link, make it also expand the submenu
        if (menuItemLink.getAttribute('href') === '#') menuItemLink.addEventListener('click', function(event) {
            event.preventDefault();
            menuItemButton.click();
        });
    }
    // close the menu when escape key is pressed
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') $01defc33d8586d8c$var$closeMobileMenu();
    });
    // add a resize observer to remove the inline styles added by the animateOpen and animateClose functions
    const resizeObserver = new ResizeObserver((entries)=>{
        for (const entry of entries){
            if (entry.contentBoxSize) {
                if (entry.contentBoxSize[0].inlineSize > mobileBreakpoint) $01defc33d8586d8c$var$removeMobileStyles();
            }
        }
    });
    resizeObserver.observe(document.body);
}


// nb. This is for IE10 and lower _only_.
var $9ddf0b85e22976d8$var$supportCustomEvent = window.CustomEvent;
if (!$9ddf0b85e22976d8$var$supportCustomEvent || typeof $9ddf0b85e22976d8$var$supportCustomEvent === 'object') {
    $9ddf0b85e22976d8$var$supportCustomEvent = function CustomEvent(event, x) {
        x = x || {};
        var ev = document.createEvent('CustomEvent');
        ev.initCustomEvent(event, !!x.bubbles, !!x.cancelable, x.detail || null);
        return ev;
    };
    $9ddf0b85e22976d8$var$supportCustomEvent.prototype = window.Event.prototype;
}
/**
 * Dispatches the passed event to both an "on<type>" handler as well as via the
 * normal dispatch operation. Does not bubble.
 *
 * @param {!EventTarget} target
 * @param {!Event} event
 * @return {boolean}
 */ function $9ddf0b85e22976d8$var$safeDispatchEvent(target, event) {
    var check = 'on' + event.type.toLowerCase();
    if (typeof target[check] === 'function') target[check](event);
    return target.dispatchEvent(event);
}
/**
 * @param {Element} el to check for stacking context
 * @return {boolean} whether this el or its parents creates a stacking context
 */ function $9ddf0b85e22976d8$var$createsStackingContext(el) {
    while(el && el !== document.body){
        var s = window.getComputedStyle(el);
        var invalid = function(k, ok) {
            return !(s[k] === undefined || s[k] === ok);
        };
        if (s.opacity < 1 || invalid('zIndex', 'auto') || invalid('transform', 'none') || invalid('mixBlendMode', 'normal') || invalid('filter', 'none') || invalid('perspective', 'none') || s['isolation'] === 'isolate' || s.position === 'fixed' || s.webkitOverflowScrolling === 'touch') return true;
        el = el.parentElement;
    }
    return false;
}
/**
 * Finds the nearest <dialog> from the passed element.
 *
 * @param {Element} el to search from
 * @return {HTMLDialogElement} dialog found
 */ function $9ddf0b85e22976d8$var$findNearestDialog(el) {
    while(el){
        if (el.localName === 'dialog') return /** @type {HTMLDialogElement} */ el;
        if (el.parentElement) el = el.parentElement;
        else if (el.parentNode) el = el.parentNode.host;
        else el = null;
    }
    return null;
}
/**
 * Blur the specified element, as long as it's not the HTML body element.
 * This works around an IE9/10 bug - blurring the body causes Windows to
 * blur the whole application.
 *
 * @param {Element} el to blur
 */ function $9ddf0b85e22976d8$var$safeBlur(el) {
    // Find the actual focused element when the active element is inside a shadow root
    while(el && el.shadowRoot && el.shadowRoot.activeElement)el = el.shadowRoot.activeElement;
    if (el && el.blur && el !== document.body) el.blur();
}
/**
 * @param {!NodeList} nodeList to search
 * @param {Node} node to find
 * @return {boolean} whether node is inside nodeList
 */ function $9ddf0b85e22976d8$var$inNodeList(nodeList, node) {
    for(var i = 0; i < nodeList.length; ++i){
        if (nodeList[i] === node) return true;
    }
    return false;
}
/**
 * @param {HTMLFormElement} el to check
 * @return {boolean} whether this form has method="dialog"
 */ function $9ddf0b85e22976d8$var$isFormMethodDialog(el) {
    if (!el || !el.hasAttribute('method')) return false;
    return el.getAttribute('method').toLowerCase() === 'dialog';
}
/**
 * @param {!DocumentFragment|!Element} hostElement
 * @return {?Element}
 */ function $9ddf0b85e22976d8$var$findFocusableElementWithin(hostElement) {
    // Note that this is 'any focusable area'. This list is probably not exhaustive, but the
    // alternative involves stepping through and trying to focus everything.
    var opts = [
        'button',
        'input',
        'keygen',
        'select',
        'textarea'
    ];
    var query = opts.map(function(el) {
        return el + ':not([disabled])';
    });
    // TODO(samthor): tabindex values that are not numeric are not focusable.
    query.push('[tabindex]:not([disabled]):not([tabindex=""])'); // tabindex != "", not disabled
    var target = hostElement.querySelector(query.join(', '));
    if (!target && 'attachShadow' in Element.prototype) {
        // If we haven't found a focusable target, see if the host element contains an element
        // which has a shadowRoot.
        // Recursively search for the first focusable item in shadow roots.
        var elems = hostElement.querySelectorAll('*');
        for(var i = 0; i < elems.length; i++)if (elems[i].tagName && elems[i].shadowRoot) {
            target = $9ddf0b85e22976d8$var$findFocusableElementWithin(elems[i].shadowRoot);
            if (target) break;
        }
    }
    return target;
}
/**
 * Determines if an element is attached to the DOM.
 * @param {Element} element to check
 * @return {boolean} whether the element is in DOM
 */ function $9ddf0b85e22976d8$var$isConnected(element) {
    return element.isConnected || document.body.contains(element);
}
/**
 * @param {!Event} event
 * @return {?Element}
 */ function $9ddf0b85e22976d8$var$findFormSubmitter(event) {
    if (event.submitter) return event.submitter;
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return null;
    var submitter = $9ddf0b85e22976d8$var$dialogPolyfill.formSubmitter;
    if (!submitter) {
        var target = event.target;
        var root = 'getRootNode' in target && target.getRootNode() || document;
        submitter = root.activeElement;
    }
    if (!submitter || submitter.form !== form) return null;
    return submitter;
}
/**
 * @param {!Event} event
 */ function $9ddf0b85e22976d8$var$maybeHandleSubmit(event) {
    if (event.defaultPrevented) return;
    var form = /** @type {!HTMLFormElement} */ event.target;
    // We'd have a value if we clicked on an imagemap.
    var value = $9ddf0b85e22976d8$var$dialogPolyfill.imagemapUseValue;
    var submitter = $9ddf0b85e22976d8$var$findFormSubmitter(event);
    if (value === null && submitter) value = submitter.value;
    // There should always be a dialog as this handler is added specifically on them, but check just
    // in case.
    var dialog = $9ddf0b85e22976d8$var$findNearestDialog(form);
    if (!dialog) return;
    // Prefer formmethod on the button.
    var formmethod = submitter && submitter.getAttribute('formmethod') || form.getAttribute('method');
    if (formmethod !== 'dialog') return;
    event.preventDefault();
    if (value != null) // nb. we explicitly check against null/undefined
    dialog.close(value);
    else dialog.close();
}
/**
 * @param {!HTMLDialogElement} dialog to upgrade
 * @constructor
 */ function $9ddf0b85e22976d8$var$dialogPolyfillInfo(dialog) {
    this.dialog_ = dialog;
    this.replacedStyleTop_ = false;
    this.openAsModal_ = false;
    // Set a11y role. Browsers that support dialog implicitly know this already.
    if (!dialog.hasAttribute('role')) dialog.setAttribute('role', 'dialog');
    dialog.show = this.show.bind(this);
    dialog.showModal = this.showModal.bind(this);
    dialog.close = this.close.bind(this);
    dialog.addEventListener('submit', $9ddf0b85e22976d8$var$maybeHandleSubmit, false);
    if (!('returnValue' in dialog)) dialog.returnValue = '';
    if ('MutationObserver' in window) {
        var mo = new MutationObserver(this.maybeHideModal.bind(this));
        mo.observe(dialog, {
            attributes: true,
            attributeFilter: [
                'open'
            ]
        });
    } else {
        // IE10 and below support. Note that DOMNodeRemoved etc fire _before_ removal. They also
        // seem to fire even if the element was removed as part of a parent removal. Use the removed
        // events to force downgrade (useful if removed/immediately added).
        var removed = false;
        var cb = (function() {
            removed ? this.downgradeModal() : this.maybeHideModal();
            removed = false;
        }).bind(this);
        var timeout;
        var delayModel = function(ev) {
            if (ev.target !== dialog) return;
             // not for a child element
            var cand = 'DOMNodeRemoved';
            removed |= ev.type.substr(0, cand.length) === cand;
            window.clearTimeout(timeout);
            timeout = window.setTimeout(cb, 0);
        };
        [
            'DOMAttrModified',
            'DOMNodeRemoved',
            'DOMNodeRemovedFromDocument'
        ].forEach(function(name) {
            dialog.addEventListener(name, delayModel);
        });
    }
    // Note that the DOM is observed inside DialogManager while any dialog
    // is being displayed as a modal, to catch modal removal from the DOM.
    Object.defineProperty(dialog, 'open', {
        set: this.setOpen.bind(this),
        get: dialog.hasAttribute.bind(dialog, 'open')
    });
    this.backdrop_ = document.createElement('div');
    this.backdrop_.className = 'backdrop';
    this.backdrop_.addEventListener('mouseup', this.backdropMouseEvent_.bind(this));
    this.backdrop_.addEventListener('mousedown', this.backdropMouseEvent_.bind(this));
    this.backdrop_.addEventListener('click', this.backdropMouseEvent_.bind(this));
}
$9ddf0b85e22976d8$var$dialogPolyfillInfo.prototype = /** @type {HTMLDialogElement.prototype} */ {
    get dialog () {
        return this.dialog_;
    },
    /**
   * Maybe remove this dialog from the modal top layer. This is called when
   * a modal dialog may no longer be tenable, e.g., when the dialog is no
   * longer open or is no longer part of the DOM.
   */ maybeHideModal: function() {
        if (this.dialog_.hasAttribute('open') && $9ddf0b85e22976d8$var$isConnected(this.dialog_)) return;
        this.downgradeModal();
    },
    /**
   * Remove this dialog from the modal top layer, leaving it as a non-modal.
   */ downgradeModal: function() {
        if (!this.openAsModal_) return;
        this.openAsModal_ = false;
        this.dialog_.style.zIndex = '';
        // This won't match the native <dialog> exactly because if the user set top on a centered
        // polyfill dialog, that top gets thrown away when the dialog is closed. Not sure it's
        // possible to polyfill this perfectly.
        if (this.replacedStyleTop_) {
            this.dialog_.style.top = '';
            this.replacedStyleTop_ = false;
        }
        // Clear the backdrop and remove from the manager.
        this.backdrop_.parentNode && this.backdrop_.parentNode.removeChild(this.backdrop_);
        $9ddf0b85e22976d8$var$dialogPolyfill.dm.removeDialog(this);
    },
    /**
   * @param {boolean} value whether to open or close this dialog
   */ setOpen: function(value) {
        if (value) this.dialog_.hasAttribute('open') || this.dialog_.setAttribute('open', '');
        else {
            this.dialog_.removeAttribute('open');
            this.maybeHideModal(); // nb. redundant with MutationObserver
        }
    },
    /**
   * Handles mouse events ('mouseup', 'mousedown', 'click') on the fake .backdrop element, redirecting them as if
   * they were on the dialog itself.
   *
   * @param {!Event} e to redirect
   */ backdropMouseEvent_: function(e) {
        if (!this.dialog_.hasAttribute('tabindex')) {
            // Clicking on the backdrop should move the implicit cursor, even if dialog cannot be
            // focused. Create a fake thing to focus on. If the backdrop was _before_ the dialog, this
            // would not be needed - clicks would move the implicit cursor there.
            var fake = document.createElement('div');
            this.dialog_.insertBefore(fake, this.dialog_.firstChild);
            fake.tabIndex = -1;
            fake.focus();
            this.dialog_.removeChild(fake);
        } else this.dialog_.focus();
        var redirectedEvent = document.createEvent('MouseEvents');
        redirectedEvent.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget);
        this.dialog_.dispatchEvent(redirectedEvent);
        e.stopPropagation();
    },
    /**
   * Focuses on the first focusable element within the dialog. This will always blur the current
   * focus, even if nothing within the dialog is found.
   */ focus_: function() {
        // Find element with `autofocus` attribute, or fall back to the first form/tabindex control.
        var target = this.dialog_.querySelector('[autofocus]:not([disabled])');
        if (!target && this.dialog_.tabIndex >= 0) target = this.dialog_;
        if (!target) target = $9ddf0b85e22976d8$var$findFocusableElementWithin(this.dialog_);
        $9ddf0b85e22976d8$var$safeBlur(document.activeElement);
        target && target.focus();
    },
    /**
   * Sets the zIndex for the backdrop and dialog.
   *
   * @param {number} dialogZ
   * @param {number} backdropZ
   */ updateZIndex: function(dialogZ, backdropZ) {
        if (dialogZ < backdropZ) throw new Error('dialogZ should never be < backdropZ');
        this.dialog_.style.zIndex = dialogZ;
        this.backdrop_.style.zIndex = backdropZ;
    },
    /**
   * Shows the dialog. If the dialog is already open, this does nothing.
   */ show: function() {
        if (!this.dialog_.open) {
            this.setOpen(true);
            this.focus_();
        }
    },
    /**
   * Show this dialog modally.
   */ showModal: function() {
        if (this.dialog_.hasAttribute('open')) throw new Error('Failed to execute \'showModal\' on dialog: The element is already open, and therefore cannot be opened modally.');
        if (!$9ddf0b85e22976d8$var$isConnected(this.dialog_)) throw new Error('Failed to execute \'showModal\' on dialog: The element is not in a Document.');
        if (!$9ddf0b85e22976d8$var$dialogPolyfill.dm.pushDialog(this)) throw new Error('Failed to execute \'showModal\' on dialog: There are too many open modal dialogs.');
        if ($9ddf0b85e22976d8$var$createsStackingContext(this.dialog_.parentElement)) console.warn("A dialog is being shown inside a stacking context. This may cause it to be unusable. For more information, see this link: https://github.com/GoogleChrome/dialog-polyfill/#stacking-context");
        this.setOpen(true);
        this.openAsModal_ = true;
        // Optionally center vertically, relative to the current viewport.
        if ($9ddf0b85e22976d8$var$dialogPolyfill.needsCentering(this.dialog_)) {
            $9ddf0b85e22976d8$var$dialogPolyfill.reposition(this.dialog_);
            this.replacedStyleTop_ = true;
        } else this.replacedStyleTop_ = false;
        // Insert backdrop.
        this.dialog_.parentNode.insertBefore(this.backdrop_, this.dialog_.nextSibling);
        // Focus on whatever inside the dialog.
        this.focus_();
    },
    /**
   * Closes this HTMLDialogElement. This is optional vs clearing the open
   * attribute, however this fires a 'close' event.
   *
   * @param {string=} opt_returnValue to use as the returnValue
   */ close: function(opt_returnValue) {
        if (!this.dialog_.hasAttribute('open')) throw new Error('Failed to execute \'close\' on dialog: The element does not have an \'open\' attribute, and therefore cannot be closed.');
        this.setOpen(false);
        // Leave returnValue untouched in case it was set directly on the element
        if (opt_returnValue !== undefined) this.dialog_.returnValue = opt_returnValue;
        // Triggering "close" event for any attached listeners on the <dialog>.
        var closeEvent = new $9ddf0b85e22976d8$var$supportCustomEvent('close', {
            bubbles: false,
            cancelable: false
        });
        $9ddf0b85e22976d8$var$safeDispatchEvent(this.dialog_, closeEvent);
    }
};
var $9ddf0b85e22976d8$var$dialogPolyfill = {};
$9ddf0b85e22976d8$var$dialogPolyfill.reposition = function(element) {
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    var topValue = scrollTop + (window.innerHeight - element.offsetHeight) / 2;
    element.style.top = Math.max(scrollTop, topValue) + 'px';
};
$9ddf0b85e22976d8$var$dialogPolyfill.isInlinePositionSetByStylesheet = function(element) {
    for(var i = 0; i < document.styleSheets.length; ++i){
        var styleSheet = document.styleSheets[i];
        var cssRules = null;
        // Some browsers throw on cssRules.
        try {
            cssRules = styleSheet.cssRules;
        } catch (e) {}
        if (!cssRules) continue;
        for(var j = 0; j < cssRules.length; ++j){
            var rule = cssRules[j];
            var selectedNodes = null;
            // Ignore errors on invalid selector texts.
            try {
                selectedNodes = document.querySelectorAll(rule.selectorText);
            } catch (e) {}
            if (!selectedNodes || !$9ddf0b85e22976d8$var$inNodeList(selectedNodes, element)) continue;
            var cssTop = rule.style.getPropertyValue('top');
            var cssBottom = rule.style.getPropertyValue('bottom');
            if (cssTop && cssTop !== 'auto' || cssBottom && cssBottom !== 'auto') return true;
        }
    }
    return false;
};
$9ddf0b85e22976d8$var$dialogPolyfill.needsCentering = function(dialog) {
    var computedStyle = window.getComputedStyle(dialog);
    if (computedStyle.position !== 'absolute') return false;
    // We must determine whether the top/bottom specified value is non-auto.  In
    // WebKit/Blink, checking computedStyle.top == 'auto' is sufficient, but
    // Firefox returns the used value. So we do this crazy thing instead: check
    // the inline style and then go through CSS rules.
    if (dialog.style.top !== 'auto' && dialog.style.top !== '' || dialog.style.bottom !== 'auto' && dialog.style.bottom !== '') return false;
    return !$9ddf0b85e22976d8$var$dialogPolyfill.isInlinePositionSetByStylesheet(dialog);
};
/**
 * @param {!Element} element to force upgrade
 */ $9ddf0b85e22976d8$var$dialogPolyfill.forceRegisterDialog = function(element) {
    if (window.HTMLDialogElement || element.showModal) console.warn("This browser already supports <dialog>, the polyfill may not work correctly", element);
    if (element.localName !== 'dialog') throw new Error('Failed to register dialog: The element is not a dialog.');
    new $9ddf0b85e22976d8$var$dialogPolyfillInfo(/** @type {!HTMLDialogElement} */ element);
};
/**
 * @param {!Element} element to upgrade, if necessary
 */ $9ddf0b85e22976d8$var$dialogPolyfill.registerDialog = function(element) {
    if (!element.showModal) $9ddf0b85e22976d8$var$dialogPolyfill.forceRegisterDialog(element);
};
/**
 * @constructor
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager = function() {
    /** @type {!Array<!dialogPolyfillInfo>} */ this.pendingDialogStack = [];
    var checkDOM = this.checkDOM_.bind(this);
    // The overlay is used to simulate how a modal dialog blocks the document.
    // The blocking dialog is positioned on top of the overlay, and the rest of
    // the dialogs on the pending dialog stack are positioned below it. In the
    // actual implementation, the modal dialog stacking is controlled by the
    // top layer, where z-index has no effect.
    this.overlay = document.createElement('div');
    this.overlay.className = '_dialog_overlay';
    this.overlay.addEventListener('click', (function(e) {
        this.forwardTab_ = undefined;
        e.stopPropagation();
        checkDOM([]); // sanity-check DOM
    }).bind(this));
    this.handleKey_ = this.handleKey_.bind(this);
    this.handleFocus_ = this.handleFocus_.bind(this);
    this.zIndexLow_ = 100000;
    this.zIndexHigh_ = 100150;
    this.forwardTab_ = undefined;
    if ('MutationObserver' in window) this.mo_ = new MutationObserver(function(records) {
        var removed = [];
        records.forEach(function(rec) {
            for(var i = 0, c; c = rec.removedNodes[i]; ++i){
                if (!(c instanceof Element)) continue;
                else if (c.localName === 'dialog') removed.push(c);
                removed = removed.concat(c.querySelectorAll('dialog'));
            }
        });
        removed.length && checkDOM(removed);
    });
};
/**
 * Called on the first modal dialog being shown. Adds the overlay and related
 * handlers.
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.blockDocument = function() {
    document.documentElement.addEventListener('focus', this.handleFocus_, true);
    document.addEventListener('keydown', this.handleKey_);
    this.mo_ && this.mo_.observe(document, {
        childList: true,
        subtree: true
    });
};
/**
 * Called on the first modal dialog being removed, i.e., when no more modal
 * dialogs are visible.
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.unblockDocument = function() {
    document.documentElement.removeEventListener('focus', this.handleFocus_, true);
    document.removeEventListener('keydown', this.handleKey_);
    this.mo_ && this.mo_.disconnect();
};
/**
 * Updates the stacking of all known dialogs.
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.updateStacking = function() {
    var zIndex = this.zIndexHigh_;
    for(var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i){
        dpi.updateZIndex(--zIndex, --zIndex);
        if (i === 0) this.overlay.style.zIndex = --zIndex;
    }
    // Make the overlay a sibling of the dialog itself.
    var last = this.pendingDialogStack[0];
    if (last) {
        var p = last.dialog.parentNode || document.body;
        p.appendChild(this.overlay);
    } else if (this.overlay.parentNode) this.overlay.parentNode.removeChild(this.overlay);
};
/**
 * @param {Element} candidate to check if contained or is the top-most modal dialog
 * @return {boolean} whether candidate is contained in top dialog
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.containedByTopDialog_ = function(candidate) {
    while(candidate = $9ddf0b85e22976d8$var$findNearestDialog(candidate)){
        for(var i = 0, dpi; dpi = this.pendingDialogStack[i]; ++i){
            if (dpi.dialog === candidate) return i === 0; // only valid if top-most
        }
        candidate = candidate.parentElement;
    }
    return false;
};
$9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.handleFocus_ = function(event) {
    var target = event.composedPath ? event.composedPath()[0] : event.target;
    if (this.containedByTopDialog_(target)) return;
    if (document.activeElement === document.documentElement) return;
    event.preventDefault();
    event.stopPropagation();
    $9ddf0b85e22976d8$var$safeBlur(/** @type {Element} */ target);
    if (this.forwardTab_ === undefined) return;
     // move focus only from a tab key
    var dpi = this.pendingDialogStack[0];
    var dialog = dpi.dialog;
    var position = dialog.compareDocumentPosition(target);
    if (position & Node.DOCUMENT_POSITION_PRECEDING) {
        if (this.forwardTab_) // forward
        dpi.focus_();
        else if (target !== document.documentElement) // backwards if we're not already focused on <html>
        document.documentElement.focus();
    }
    return false;
};
$9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.handleKey_ = function(event) {
    this.forwardTab_ = undefined;
    if (event.keyCode === 27) {
        event.preventDefault();
        event.stopPropagation();
        var cancelEvent = new $9ddf0b85e22976d8$var$supportCustomEvent('cancel', {
            bubbles: false,
            cancelable: true
        });
        var dpi = this.pendingDialogStack[0];
        if (dpi && $9ddf0b85e22976d8$var$safeDispatchEvent(dpi.dialog, cancelEvent)) dpi.dialog.close();
    } else if (event.keyCode === 9) this.forwardTab_ = !event.shiftKey;
};
/**
 * Finds and downgrades any known modal dialogs that are no longer displayed. Dialogs that are
 * removed and immediately readded don't stay modal, they become normal.
 *
 * @param {!Array<!HTMLDialogElement>} removed that have definitely been removed
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.checkDOM_ = function(removed) {
    // This operates on a clone because it may cause it to change. Each change also calls
    // updateStacking, which only actually needs to happen once. But who removes many modal dialogs
    // at a time?!
    var clone = this.pendingDialogStack.slice();
    clone.forEach(function(dpi) {
        if (removed.indexOf(dpi.dialog) !== -1) dpi.downgradeModal();
        else dpi.maybeHideModal();
    });
};
/**
 * @param {!dialogPolyfillInfo} dpi
 * @return {boolean} whether the dialog was allowed
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.pushDialog = function(dpi) {
    var allowed = (this.zIndexHigh_ - this.zIndexLow_) / 2 - 1;
    if (this.pendingDialogStack.length >= allowed) return false;
    if (this.pendingDialogStack.unshift(dpi) === 1) this.blockDocument();
    this.updateStacking();
    return true;
};
/**
 * @param {!dialogPolyfillInfo} dpi
 */ $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager.prototype.removeDialog = function(dpi) {
    var index = this.pendingDialogStack.indexOf(dpi);
    if (index === -1) return;
    this.pendingDialogStack.splice(index, 1);
    if (this.pendingDialogStack.length === 0) this.unblockDocument();
    this.updateStacking();
};
$9ddf0b85e22976d8$var$dialogPolyfill.dm = new $9ddf0b85e22976d8$var$dialogPolyfill.DialogManager();
$9ddf0b85e22976d8$var$dialogPolyfill.formSubmitter = null;
$9ddf0b85e22976d8$var$dialogPolyfill.imagemapUseValue = null;
/**
 * Installs global handlers, such as click listers and native method overrides. These are needed
 * even if a no dialog is registered, as they deal with <form method="dialog">.
 */ if (window.HTMLDialogElement === undefined) {
    /**
   * If HTMLFormElement translates method="DIALOG" into 'get', then replace the descriptor with
   * one that returns the correct value.
   */ var $9ddf0b85e22976d8$var$testForm = document.createElement('form');
    $9ddf0b85e22976d8$var$testForm.setAttribute('method', 'dialog');
    if ($9ddf0b85e22976d8$var$testForm.method !== 'dialog') {
        var $9ddf0b85e22976d8$var$methodDescriptor = Object.getOwnPropertyDescriptor(HTMLFormElement.prototype, 'method');
        if ($9ddf0b85e22976d8$var$methodDescriptor) {
            // nb. Some older iOS and older PhantomJS fail to return the descriptor. Don't do anything
            // and don't bother to update the element.
            var $9ddf0b85e22976d8$var$realGet = $9ddf0b85e22976d8$var$methodDescriptor.get;
            $9ddf0b85e22976d8$var$methodDescriptor.get = function() {
                if ($9ddf0b85e22976d8$var$isFormMethodDialog(this)) return 'dialog';
                return $9ddf0b85e22976d8$var$realGet.call(this);
            };
            var $9ddf0b85e22976d8$var$realSet = $9ddf0b85e22976d8$var$methodDescriptor.set;
            /** @this {HTMLElement} */ $9ddf0b85e22976d8$var$methodDescriptor.set = function(v) {
                if (typeof v === 'string' && v.toLowerCase() === 'dialog') return this.setAttribute('method', v);
                return $9ddf0b85e22976d8$var$realSet.call(this, v);
            };
            Object.defineProperty(HTMLFormElement.prototype, 'method', $9ddf0b85e22976d8$var$methodDescriptor);
        }
    }
    /**
   * Global 'click' handler, to capture the <input type="submit"> or <button> element which has
   * submitted a <form method="dialog">. Needed as Safari and others don't report this inside
   * document.activeElement.
   */ document.addEventListener('click', function(ev) {
        $9ddf0b85e22976d8$var$dialogPolyfill.formSubmitter = null;
        $9ddf0b85e22976d8$var$dialogPolyfill.imagemapUseValue = null;
        if (ev.defaultPrevented) return;
         // e.g. a submit which prevents default submission
        var target = /** @type {Element} */ ev.target;
        if ('composedPath' in ev) {
            var path = ev.composedPath();
            target = path.shift() || target;
        }
        if (!target || !$9ddf0b85e22976d8$var$isFormMethodDialog(target.form)) return;
        var valid = target.type === 'submit' && [
            'button',
            'input'
        ].indexOf(target.localName) > -1;
        if (!valid) {
            if (!(target.localName === 'input' && target.type === 'image')) return;
            // this is a <input type="image">, which can submit forms
            $9ddf0b85e22976d8$var$dialogPolyfill.imagemapUseValue = ev.offsetX + ',' + ev.offsetY;
        }
        var dialog = $9ddf0b85e22976d8$var$findNearestDialog(target);
        if (!dialog) return;
        $9ddf0b85e22976d8$var$dialogPolyfill.formSubmitter = target;
    }, false);
    /**
   * Global 'submit' handler. This handles submits of `method="dialog"` which are invalid, i.e.,
   * outside a dialog. They get prevented.
   */ document.addEventListener('submit', function(ev) {
        var form = ev.target;
        var dialog = $9ddf0b85e22976d8$var$findNearestDialog(form);
        if (dialog) return; // ignore, handle there
        var submitter = $9ddf0b85e22976d8$var$findFormSubmitter(ev);
        var formmethod = submitter && submitter.getAttribute('formmethod') || form.getAttribute('method');
        if (formmethod === 'dialog') ev.preventDefault();
    });
    /**
   * Replace the native HTMLFormElement.submit() method, as it won't fire the
   * submit event and give us a chance to respond.
   */ var $9ddf0b85e22976d8$var$nativeFormSubmit = HTMLFormElement.prototype.submit;
    var $9ddf0b85e22976d8$var$replacementFormSubmit = function() {
        if (!$9ddf0b85e22976d8$var$isFormMethodDialog(this)) return $9ddf0b85e22976d8$var$nativeFormSubmit.call(this);
        var dialog = $9ddf0b85e22976d8$var$findNearestDialog(this);
        dialog && dialog.close();
    };
    HTMLFormElement.prototype.submit = $9ddf0b85e22976d8$var$replacementFormSubmit;
}
var $9ddf0b85e22976d8$export$2e2bcd8739ae039 = $9ddf0b85e22976d8$var$dialogPolyfill;


/**
 * Search Modal
 *
 * Generates a dialog element for the search modal when the search icon is clicked
 *
 */ function $d4079664453d73d8$export$3477887ca54d82a() {
    const searchDialog = document.getElementById('search-modal');
    // Return early if the search modal doesn't exist.
    if (!searchDialog) return;
    (0, $9ddf0b85e22976d8$export$2e2bcd8739ae039).registerDialog(searchDialog);
    // add the event listener for the search close button
    const searchCloseButton = searchDialog.querySelector('[data-action="close-search-modal"]');
    searchCloseButton.addEventListener('click', function() {
        searchDialog.close();
    });
    // close modal on escape key press
    window.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') searchDialog.close();
    });
    // close modal on click outside modal
    window.addEventListener('click', function(event) {
        if (event.target === searchDialog) searchDialog.close();
    });
    const searchButtons = document.querySelectorAll('[data-action="open-search-modal"]');
    searchButtons.forEach((button)=>{
        button.addEventListener('click', function(event) {
            event.preventDefault();
            if (searchDialog) {
                searchDialog.showModal();
                // Focus the search input when the modal is opened, after a delay
                setTimeout(()=>{
                    searchDialog.querySelector('input[type="text"]').select();
                }, 300);
            }
        });
    });
}


const $e70459056c847cc6$var$ADD_SCROLL_CLASS_AFTER = 100;
const $e70459056c847cc6$var$REMOVE_SCROLL_CLASS_AFTER = 20;
/**
 * Updates custom CSS properties for the header height and combined header and navigation heights
 * based on the provided site header and section navigation elements.
 *
 * @param {HTMLElement} siteHeader - The site header element used to calculate its height.
 *
 * @return {void}
 */ function $e70459056c847cc6$var$updateHeightCustomProperty(siteHeader) {
    const siteHeaderHeight = siteHeader.offsetHeight;
    document.body.style.setProperty('--site-header-height', siteHeaderHeight + 'px');
}
/**
 * Applies sticky header behavior to the site header and section navigation elements.
 * Saves the height of the site header and section navigation elements in custom properties to be used in CSS.
 *
 * @return {void}
 */ function $e70459056c847cc6$export$3a703b1e35417389() {
    const siteHeader = document.querySelector('#masthead');
    // Check if the site header exists.
    if (!siteHeader) return;
    // Observe siteHeader and section navs for resizing.
    const observer = new ResizeObserver(()=>{
        $e70459056c847cc6$var$updateHeightCustomProperty(siteHeader);
    });
    // TODO: Only needed when other elements care about the height of the header.
    observer.observe(siteHeader);
    let ticking = false;
    // Listen for the page to scroll and add a class to the body once it's past a certain point.
    window.addEventListener('scroll', ()=>{
        if (!ticking) {
            window.requestAnimationFrame(()=>{
                if (window.scrollY > $e70459056c847cc6$var$ADD_SCROLL_CLASS_AFTER) document.body.classList.add('has-scrolled');
                else if (window.scrollY < $e70459056c847cc6$var$REMOVE_SCROLL_CLASS_AFTER) document.body.classList.remove('has-scrolled');
                ticking = false;
            });
            ticking = true;
        }
    });
}


// run all functions on page load.
document.addEventListener('DOMContentLoaded', function() {
    (0, $810e55176b9a1362$export$2c14ca4feaecad60)();
    (0, $bea2d471bd0cd2e0$export$20a6ab5ff56edf57)();
    (0, $01defc33d8586d8c$export$c8c5a7f7fe721969)();
    (0, $d4079664453d73d8$export$3477887ca54d82a)();
    (0, $e70459056c847cc6$export$3a703b1e35417389)();
});

})();
//# sourceMappingURL=main.js.map
